module.exports = __webpack_public_path__ + "static/media/56pic.36db3abe.jpg";